import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class AssetsService extends AxiosService {
    constructor() {
        super('management');
    }
  
    getAssetsList = async (page, limit, search = null, { cancelToken = null } = {}) => {
        let query;
        if (search) {
            query = `/assets/list/?page=${page}&limit=${limit}&search=${search}`;
        } else {
            query = `/assets/list/?page=${page}&limit=${limit}`;
        }
        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
        return response;
    };

    createAsset = async (data, { cancelToken = null } = {}) => {
        return await this.post(
            `/assets`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    editAsset = async (data, { cancelToken = null } = {}) => {
        return await this.put(
            `/assets/${data.assetId}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    markReserved = async (assetId, { cancelToken = null } = {}) => {
        return await this.get(
            `/assets/${assetId}/set-reserved`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    markAvailable = async (assetId, { cancelToken = null } = {}) => {
        return await this.get(
            `/assets/${assetId}/set-available`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    deleteAsset = async (assetId, { cancelToken = null } = {}) => {
        return await this.delete(
            `/assets/${assetId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getAvailableAssets = async (page, limit, search = null, typeFilter = null, { cancelToken = null } = {}) => {
        let query = `/assets/available/?page=${page}&limit=${limit}`;
        if (search) {
            query += `&search=${search}`;
        }

        if (typeFilter) {
            query += `&type=${typeFilter}`;
        }

        return await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getAssetTypes = async ({ cancelToken = null } = {}) => {
        return await this.get(
            "/assets/types",
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

}
export default new AssetsService();
